export const loyaltyInfo = {
  from: "From",
  to: "To",
  action: "Action",
  amount: "Amount",
  openAmount: "Open Amount",
  closeAmount: "Close Amount",
  remarks: "Remarks",
  dateReceived: "Date Received",
  close: "Close",
};
